export default __webpack_public_path__ + "images/DW.06ee4fa.png";